import { trackUetQuoteConversion } from '../analytics';

export const trackEvent = (eventName: string, eventParams?: Record<string, any>) => {
  trackUetQuoteConversion(eventName, eventParams);

  if (typeof window !== 'undefined' && (window as any).gtag) {
    (window as any).gtag('event', eventName, eventParams);
  }
};

export const trackQuoteFunnelStepView = (
  stepName: string,
  eventParams?: Record<string, any>
) => {
  trackEvent('quote_funnel_step_view', {
    ...eventParams,
    funnel_name: 'quote_form',
    step_name: stepName,
  });
};
